import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import CreateTableComponent from "../../share/CreateTableComponent";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report58Component() {

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [othYearSelected, setOThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [Re58data, setRe58data] = useState([]);
    const [openModalForm, setOpenModalForm] = React.useState(false);
    const [Re58detail, setRe58detail] = React.useState([]);
    const [status, setStatus] = React.useState("0");
    const [R58detailfilter, setR58detailfilter] = React.useState([]);
    pdfMake.fonts = {
        THSarabunNew: {
            normal: 'THSarabunNew.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNewn BoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
        }
    }

    async function getR58() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("othYear", othYearSelected);
        const res58 = await fetch("/api/Support/getR58", {
            method: 'POST',
            body: formData
        })
        const Re58data = await res58.json()
        setRe58data(Re58data.dataenum);
        console.log(Re58data)
    }

    const [Re58yeardata, setRe58yeardata] = React.useState([]);

    async function getR58year() {
        const res = await fetch("/api/Support/getyear57")
        const Re58yeardata = await res.json()
        setRe58yeardata(Re58yeardata.dataenum)
        console.log(Re58yeardata)
    }


    const y2 = Re58yeardata.filter(n => n.yearTh >= othYearSelected);

    const tableHeaders = y2.map((item, i) => (
        <>
            <th key={`header-${i}-1`} className='text-center'>
                แห่ง
            </th>
            <th key={`header-${i}-2`} className='text-center'>
                คน
            </th>
            <th key={`header-${i}-3`} className='text-center'>
                (บาท)
            </th>
        </>
    ));







    var col = (((thYearSelected - othYearSelected) + 1) * 3);
    var col1 = col + 6;



    const tableHeaders2 = Re58data.map(n => n.count1);

    var hidecolumn = (tableHeaders2.every(n => n >= 1)) ? false : true;
    var hidecolumn1 = (tableHeaders2.every(n => n >= 2)) ? false : true;
    var hidecolumn2 = (tableHeaders2.every(n => n >= 3)) ? false : true;
    var hidecolumn3 = (tableHeaders2.every(n => n >= 4)) ? false : true;
    var hidecolumn4 = (tableHeaders2.every(n => n >= 5)) ? false : true;
    var hidecolumn5 = (tableHeaders2.every(n => n >= 6)) ? false : true;
    var hidecolumn6 = (tableHeaders2.every(n => n >= 7)) ? false : true;
    var hidecolumn7 = (tableHeaders2.every(n => n >= 8)) ? false : true;


    React.useEffect(() => {
        getR58()
        getR58year()
    }, [thYearSelected, othYearSelected]);



    async function getR58detail(value, type) {
        const formData = new FormData();
        // console.log("thYearSelected",typeof thYearSelected);
        formData.append("thYear", thYearSelected);
        formData.append("status", String(type));
        // console.log("status",status);
        console.log("value", value);
        console.log("type", type);
        const res61 = await fetch("/api/Support/getR58detail", {
            method: 'POST',
            body: formData
        })
        const Re58data = await res61.json()
        // setRe61detail(Re61data.dataenum);
        setR58detailfilter(Re58data.dataenum.filter(
            (item) => item.supportDetail === value
        ))
        console.log(Re58data);
        modalToggleExtendCourse();
    }

    const modalToggleExtendCourse = () => {
        // getR55detail()
        setOpenModalForm(!openModalForm);
        // console.log("idmodal", value);
    }

    const COLUMNSTRAIN = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "ชื่อผู้ได้รับเงินช่วยเหลือหรืออุดหนุน",
            accessor: "supportName",
        },
        {
            Header: "เลขที่คำขอ",
            accessor: "supportNo",
        },
        {
            Header: "จำนวนคน",
            accessor: "personTotal",
            Cell: ({ value }) => {
                return (
                    <>
                        {NumberWithCommmas2(value)}

                    </>
                )

            }
        },
        {
            Header: "จำนวนเงินที่จ่ายเงินอุดหนุนแล้ว (บาท)",
            accessor: "amount",
            Cell: ({ value }) => {
                return (
                    <>
                        {NumberWithCommmas2(value)}

                    </>
                )

            }
        },
    ]

    // ===== เพิ่ม helper ไว้เหนือ return =====
    /** รวมยอด "บาท" (ช่องที่เป็น amount) ของแต่ละแถว ตามจำนวนปีที่แสดงจริง */
    const sumAmountsForRow = (row, yearsCount) => {
        let total = 0;
        const maxIndex = yearsCount * 3; // 3 คอลัมน์ต่อปี: แห่ง, คน, บาท
        for (let i = 1; i <= maxIndex; i++) {
            if (i % 3 === 0) {
                const key = `year${i}`;
                const v = Number(row?.[key]) || 0;
                total += v;
            }
        }
        return total;
    };

    /** ยอด "บาท" รวมของทุกแถว (ใช้เป็นตัวหาร) */
    const totalAmountAllRows = React.useMemo(() => {
        const yearsCount = y2.length;
        if (!yearsCount || !Array.isArray(Re58data)) return 0;
        return Re58data.reduce((acc, row) => acc + sumAmountsForRow(row, yearsCount), 0);
    }, [Re58data, y2.length]);
    return (
        <Container>
            <div>
                <div style={{ display: 'flex', paddingBottom: '20px' }}>
                    <h3 className='text-center' style={{ lineHeight: 'inherit' }}>
                        ปีงบประมาณ พ.ศ.
                    </h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            setOThYearSelected(e.target.value)
                        }}
                    >
                        {Re58yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                    <h3 style={{ lineHeight: 'inherit' }}>ถึง</h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {y2.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div>
                <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/Support/xlsxR58?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>EXCEL</Button>
                        <Button className="btn1" href={`api/SupportReports/excelR58detail?thYear=${thYearSelected}&status=${status}&othYear=${othYearSelected}`} download>EXCEL(Detail)</Button>
                        <Button className="btn2" href={`api/Support/pdfR58?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>PDF</Button>
                    </Col>
                </Row>
                <div className="outer-wrapper">
                    <div className="table-wrapper">
                        <Table className="styled-table" bordered striped hover>
                            <thead>
                                <tr>
                                    <th rowSpan="3">
                                        ลำดับ
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        รายการ
                                    </th>
                                    <th colSpan={col} className=' text-center'>
                                        อนุมัติเงินอุดหนุน
                                    </th>
                                    {/* <th colSpan="3" className=' text-center'>
                                อนุมัติเงินอุดหนุน
                            </th> */}
                                    <th rowSpan="3" className=' text-center'>
                                        ร้อยละของสัดส่วนการอนุมัติ
                                    </th>
                                </tr>
                                <tr>
                                    {/*<th colSpan="3" className='text-center' hidden={hidecolumn}>*/}
                                    {/*    ปีงบประมาณ 2559*/}
                                    {/*</th>*/}
                                    {/*<th colSpan="3" className='text-center' hidden={hidecolumn1}>*/}
                                    {/*    ปีงบประมาณ 2560*/}
                                    {/*</th>*/}
                                    {/*<th colSpan="3" className='text-center' hidden={hidecolumn2}>*/}
                                    {/*    ปีงบประมาณ 2561*/}
                                    {/*</th>*/}
                                    {/*<th colSpan="3" className='text-center' hidden={hidecolumn3}>*/}
                                    {/*    ปีงบประมาณ 2562*/}
                                    {/*</th>*/}
                                    {/*<th colSpan="3" className='text-center' hidden={hidecolumn4}>*/}
                                    {/*    ปีงบประมาณ 2563*/}
                                    {/*</th>*/}
                                    {/*<th colSpan="3" className='text-center' hidden={hidecolumn5}>*/}
                                    {/*    ปีงบประมาณ 2564*/}
                                    {/*</th>*/}
                                    {/*<th colSpan="3" className='text-center' hidden={hidecolumn6}>*/}
                                    {/*    ปีงบประมาณ 2565*/}
                                    {/*</th>*/}
                                    {/*<th colSpan="3" className='text-center' hidden={hidecolumn7}>*/}
                                    {/*    ปีงบประมาณ 2566*/}
                                    {/*</th>*/}
                                    {y2.map((item, i) => (
                                        <th colSpan="3" className='text-center' >
                                            ปีงบประมาณ {item.yearTh}
                                        </th>

                                    ))}


                                </tr>
                                <tr>
                                    {/*<th className='text-center' hidden={hidecolumn}>*/}
                                    {/*    (แห่ง)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn}>*/}
                                    {/*    คน*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn}>*/}
                                    {/*    (บาท)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn1}>*/}
                                    {/*    (แห่ง)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn1}>*/}
                                    {/*    คน*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn1}>*/}
                                    {/*    (บาท)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn2}>*/}
                                    {/*    (แห่ง)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn2}>*/}
                                    {/*    คน*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn2}>*/}
                                    {/*    (บาท)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn3}>*/}
                                    {/*    (แห่ง)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn3}>*/}
                                    {/*    คน*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn3}>*/}
                                    {/*    (บาท)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn4}>*/}
                                    {/*    (แห่ง)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn4}>*/}
                                    {/*    คน*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn4}>*/}
                                    {/*    (บาท)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn5}>*/}
                                    {/*    (แห่ง)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn5}>*/}
                                    {/*    คน*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn5}>*/}
                                    {/*    (บาท)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn6}>*/}
                                    {/*    (แห่ง)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn6}>*/}
                                    {/*    คน*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn6}>*/}
                                    {/*    (บาท)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn7}>*/}
                                    {/*    (แห่ง)*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn7}>*/}
                                    {/*    คน*/}
                                    {/*</th>*/}
                                    {/*<th className='text-center' hidden={hidecolumn7}>*/}
                                    {/*    (บาท)*/}
                                    {/*</th>*/}

                                    {tableHeaders}

                                </tr>

                            </thead>

                            <tbody>
                                {Re58data.length > 0 && Re58data.map((item, i) => (
                                    <tr >
                                        <td className='text-center'>
                                            {i + 1}
                                        </td>
                                        <td className='text-start'>
                                            {item.supportDetail}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR58detail(e.target.id, "0")
                                                }}>{Number(item.year1)}</p>
                                            {/* {item.year1} 1 */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.year2}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.year3}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.year4}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.year5}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.year6}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.year7}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.year8}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.year9}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.year10}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.year11}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.year12}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.year13}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.year14}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.year15}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.year16}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.year17}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.year18}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.year19}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.year20}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.year21}
                                        </td>
                                        <td className='text-center' hidden={hidecolumn7}>
                                            {item.year22}
                                        </td>
                                        <td className='text-center' hidden={hidecolumn7}>
                                            {item.year23}
                                        </td>
                                        <td className='text-center' hidden={hidecolumn7}>
                                            {item.year24}
                                        </td>

                                        {/*<td className='text-end'>*/}
                                        {/*    {item.sum1}*/}
                                        {/*</td>*/}
                                        {/*<td className='text-end'>*/}
                                        {/*    {item.sum2}*/}
                                        {/*</td>*/}
                                        {/*<td className='text-end'>*/}
                                        {/*    {item.sum3}*/}
                                        {/*</td>*/}
                                        <td className='text-end'>
                                            {(() => {
                                                const yearsCount = y2.length;
                                                const rowAmount = sumAmountsForRow(item, yearsCount);
                                                const pct = totalAmountAllRows > 0 ? (rowAmount / totalAmountAllRows) * 100 : 0;
                                                return `${pct.toFixed(2)}%`;
                                            })()}
                                        </td>
                                    </tr>

                                )) || <tr><td colSpan={col1} rowSpan="6" className='text-center'>No Data</td></tr>}

                            </tbody>

                        </Table>
                    </div>
                </div>
            </div>

            <Modal

                isOpen={openModalForm}
                toggle={modalToggleExtendCourse}
                // style={{ maxWidth: "600px", width: "100%" }}
                centered
                scrollable
                backdrop={'static'}
                keyboard={false}
                size="xl"

                className="modal-bordered"
            >
                <ModalHeader toggle={modalToggleExtendCourse} className="styled-modal text-center">
                    รายละเอียดข้อมูล
                </ModalHeader>
                <ModalBody >
                    <CreateTableComponent column={COLUMNSTRAIN} dataInput={R58detailfilter} showEntrie={true} showPage={true} />
                </ModalBody>
            </Modal>

        </Container>


    )
}